<template>
  <v-tabs v-model="currTab" @change="tabChanged">
    <v-tab v-for="tab in tabs" :key="tab.key"> {{ tab.label }} <v-icon small right color="red" dark v-if="tab.closable" @click="closeTab(tab.key)"> mdi-close </v-icon> </v-tab>
    <v-tab-item v-for="tab in tabs" :key="tab.key" >
      <v-container fluid>
        <v-row>
          <v-col cols="12">
            <sys-reference-view :type="tab.type" :accessKey="tabKey" @compSignal="processCompSignal"></sys-reference-view>
          </v-col>
        </v-row>
      </v-container>
    </v-tab-item>
  </v-tabs>
</template>
<script>

import SysReferenceView from '@/views/references/subpages/refView'
export default {
  name: 'sysReferencesView',
  components: {
    SysReferenceView
  },
  data () {
    return {
      selectedReference: {},
      currTab: 0,
      tabs: [
        { key: 'sysReferences', type: 'refList', label: 'Все справочники', closable: false }
      ]
    }
  },
  computed: {
    tabKey: {
      get: function () {
        return this.tabs[this.currTab].key
      }
    },
    activeTab: {
      get: function () {
        // const cTab = this.currTab
        return this.tabs[this.currTab]
      }
    }
  },
  mounted: function () {
    console.log('references::sysReferencesView::index mounted')
  },
  watch: {
    selectedReference () {
    }
  },
  methods: {
    processCompSignal (signal) {
      console.log('processCompSignal from refList accepted: ', signal)
      switch (signal.comp) {
        case 'sysReferences':
          this.addTab(signal.data)
          break
      }
    },
    addTab (tabData) {
      console.log('addTab from refList accepted: ', tabData)
      const tabExists = this.tabs.findIndex(itm => itm.key === tabData.ref_guid)
      if (tabExists !== -1) {
        console.log('tab exists ', tabExists)
        this.currTab = tabExists
        this.tabChanged()
      } else {
        console.log('Creating tab')
        const newTab = {
          key: tabData.ref_guid,
          label: tabData.reference_name,
          type: tabData.ref_guid,
          closable: true
        }
        this.tabs.push(newTab)
        this.currTab = this.tabs.findIndex(itm => itm.key === newTab.key)
        this.tabChanged()
      }
    },
    closeTab (key) {
      console.log('Request for tab close', key)
      const itmIdx = this.tabs.findIndex(itm => itm.key === key)
      this.tabs.splice(itmIdx, 1)
      this.currTab = 0
      this.tabChanged()
    },
    tabChanged () {
      console.log('Current tab is ', this.currTab)
    }
  }
}
</script>
